'use client';

import * as React from 'react';
import { authClient } from '@/lib/auth/custom/client';
// import { logger } from '@/lib/default-logger';
import { useComponentLogger } from '@/lib/component-logger';


export const UserContext = React.createContext(undefined);

export function UserProvider({ children }) {
  
  const logger = useComponentLogger("User Context");

  const [state, setState] = React.useState({
    user: null,
    error: null,
    isLoading: true,
  });


  const checkSession = React.useCallback(async () => {
    try {
      const { data, error } = await authClient.getUser();
      // logger.debug("data from usercontex", data)
      if (error) {
        logger.error(error);
        setState((prev) => ({ ...prev, user: null, error: 'Something went wrong', isLoading: false }));
        return;
      }

      setState((prev) => ({ ...prev, user: data ?? null, error: null, isLoading: false }));
    } catch (err) {
      logger.error(err);
      setState((prev) => ({ ...prev, user: null, error: 'Something went wrong', isLoading: false }));
    }
  }, []);

  const handleLogout = React.useCallback(async () => {
    try {
      const response = await authClient.signOut();
      if (response.error) {
        logger.error(response.error);
        return;
      }

      setState({ user: null, error: null, isLoading: false });
      localStorage.clear();
    } catch (error) {
      logger.error('Error during logout:', error);
    }
  }, []);



  React.useEffect(() => {
    checkSession().catch((err) => {
      logger.error(err);
      // noop
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Expected
  }, []);

  return (
    <UserContext.Provider value={{ ...state, checkSession, handleLogout,  }}>
      {children}
    </UserContext.Provider>
  );
}

export const UserConsumer = UserContext.Consumer;

